import { StatusBar } from "expo-status-bar";
import React from "react";
import PropTypes from "prop-types";
import {
  StyleSheet,
  View,
  ScrollView,
  TouchableOpacity,
  ActivityIndicator,
  TouchableWithoutFeedback,
  Platform,
  TextInput,
  Dimensions,
} from "react-native";
import Text from "app/components/Text";
import Value from "app/components/Value";
import ValueBlur from "app/components/ValueBlur";
import ValueInput from "app/components/ValueInput";
import Generation from "app/components/Generation";
// import Canvas from 'app/components/Canvas'
import apiActions from "app/utils/apiActions";
import valueActions from "app/utils/valueActions";
import storageActions from "app/utils/storageActions";
import * as RootNavigation from "app/utils/RootNavigation.js";
import textHelpers from "app/utils/textHelpers";
import colorHelpers from "app/utils/colorHelpers";
import timeHelpers from "app/utils/timeHelpers";
import valueHelpers from "app/utils/valueHelpers";
import iconHelpers from "app/utils/iconHelpers";
import { styleSheet, colors, sizes, DARK } from "app/utils/styleSheet";
import {
  Ionicons,
  Octicons,
  FontAwesome,
  Feather,
  Entypo,
  MaterialCommunityIcons,
} from "@expo/vector-icons";

// import {Sigma, RandomizeNodePositions, RelativeSize, EdgeShapes, NodeShapes, NOverlap, } from 'react-sigma';
import Graph from "react-graph-vis";
import "vis-network/dist/dist/vis-network.css";

import Hoverable from "app/components/Hoverable";
const createLogger = (msg, value) => () => {
  // console.log(msg, value.name);
};

const WEB = Platform.OS == "web";
const REVERSE = false;
const CONSTELATE = true;

export default class Tree extends React.Component {
  static navigationOptions = ({
    navigation,
    navigationOptions,
    screenProps,
  }) => {
    return {
      headerShown: false,
    };
  };

  static propTypes = {
    screenProps: PropTypes.shape({
      // values: PropTypes.arrayOf(PropTypes.object),
    }),
  };

  constructor(props) {
    super(props);
    // let { user } = props.screenProps
    // props.navigation
    this.state = {
      values: [],
      topLevel: 0,
      fetching: false,
      query: "",
      hideComplete: true,
      hierarchical: true,
      stabalize: true,
      showOnlyStarred: false,
      showHidden: 0,
      showDuplicates: false,
      mapView: false,
      showNotes: true,
      showSnoozed: 0,
      showDoneToday: 1,
      familyIds: [],
      selectedValueId: null,
      lines: [],
      quickActionsId: null,
      enableBlur: true,
      redrawKey: 0,
      scrollHeight: Dimensions.get("window").height,
      scrollHeight: null,
      hiddenIds: [],
    };

    let { navigation, route } = this.props;
    navigation.setOptions({
      headerRight: () => (
        <TouchableOpacity onPress={navigation.toggleDrawer}>
          <Ionicons
            name="ios-menu"
            size={32}
            color={colors.foreground}
            style={{ marginRight: 20 }}
          />
        </TouchableOpacity>
      ),
    });
  }

  async componentDidMount() {
    // let hiddenIds = await storageActions.fetchItem('hiddenIds')
    this.fetch();
    let pref = await apiActions.request("preferences/1");
    let hiddenIds = pref.hidden_ids;
    // let values = await storageActions.fetchItem("values");
    // if (!!values) {
    //   values = valueHelpers.sortByTimeline(values);
    //   values = textHelpers.oldestFirst(values, "id");
    //   // values = valueHelpers.applyColors(values)
    //   values = valueHelpers.applyBottomLevelParentId(values);
    //   let topLevel = valueHelpers.topLevel(values);
    //   // values = values.map(v => ({...v, level: textHelpers.determineLevel(v, values)}))
    //   this.setState({ values, hiddenIds, topLevel });
    // }
    this._unsubscribe = this.props.navigation.addListener("focus", () => {
      // this.fetch();
    });
    if (WEB && !!this.filterInput) this.filterInput.focus();
  }

  componentWillUnmount() {
    if (this._unsubscribe) this._unsubscribe();
    if (this.revolver) clearTimeout(this.revolver);
  }

  fetch = async () => {
    this.setState({ fetching: true });
    console.log("network view fetch...");
    let timestamp = Date.now();
    // let values = await apiActions.request("values");
    let values = await valueActions.index();
    let duration = (Date.now() - timestamp) / 1000;
    console.log(`fetch completed in ${duration.toFixed(2)} seconds`, values);
    if (!!values) {
      // values = valueHelpers.sortByTimeline(values);
      values = textHelpers.oldestFirst(values, "id");
      // values = valueHelpers.applyColors(values)
      values = valueHelpers.applyBottomLevelParentId(values);
      let topLevel = valueHelpers.topLevel(values);
      // values = values.map(v => ({...v, level: textHelpers.determineLevel(v, values)}))
      // let hiddenIds = await storageActions.fetchItem('hiddenIds')
      this.setState({ values, topLevel, fetching: false });
      storageActions.saveItem("values", values);
    } else console.warn("error", values);
  };

  render() {
    let { navigation } = this.props;
    let {
      values,
      fetching,
      query,
      hideComplete,
      showSnoozed,
      showOnlyStarred,
      showNotes,
      showDoneToday,
      hierarchical,
      familyIds,
      lines,
      quickActionsId,
      enableBlur,
      redrawKey,
      scrollHeight,
      showHidden,
      showDuplicates,
      mapView,
      stabalize,
    } = this.state;

    let buttonColorOptions = [
      colors.trim,
      colors.active,
      colors.activeHighlight,
    ];

    return (
      <View style={styles.container} key={redrawKey}>
        <StatusBar style="auto" />
        <View style={[styles.row, styles.queryRow]}>
          {fetching ? (
            <ActivityIndicator />
          ) : (
            <TouchableOpacity
              onPress={this.fetch}
              style={[styles.icon, { marginRight: sizes.base }]}
            >
              <Ionicons
                name="md-refresh"
                size={sizes.itemHeight}
                color={colors.active}
              />
            </TouchableOpacity>
          )}
          <TextInput
            ref={(c) => (this.filterInput = c)}
            onKeyPress={this.handleKeyPress}
            style={styles.input}
            placeholderTextColor={colors.placeholder}
            value={query}
            placeholder={"filter"}
            onChangeText={(query) => this.setState({ query })}
          />
          <TouchableOpacity
            onPress={() => this.setState({ showDuplicates: !showDuplicates })}
            style={styles.icon}
          >
            <Text
              style={{ color: showDuplicates ? colors.active : colors.trim }}
            >
              Dups
            </Text>
          </TouchableOpacity>
          <TouchableOpacity
            onPress={() => this.setState({ mapView: !mapView })}
            style={styles.icon}
          >
            <Text style={{ color: mapView ? colors.active : colors.trim }}>
              Map
            </Text>
          </TouchableOpacity>
          <TouchableOpacity
            onPress={() => this.setState({ hideComplete: !hideComplete })}
            style={styles.icon}
          >
            <Feather
              name={"check-circle"}
              size={sizes.itemHeight}
              color={hideComplete ? colors.trim : colors.active}
            />
          </TouchableOpacity>
          <TouchableOpacity
            onPress={() => this.setState({ hierarchical: !hierarchical })}
            style={{ marginLeft: sizes.base }}
          >
            <Entypo
              name="flow-tree"
              size={sizes.itemHeight}
              color={hierarchical ? colors.active : colors.trim}
            />
          </TouchableOpacity>
          <TouchableOpacity
            onPress={() => this.setState({ stabalize: !stabalize })}
            style={{ marginLeft: sizes.base }}
          >
            <FontAwesome
              name="anchor"
              size={sizes.itemHeight}
              color={stabalize ? colors.active : colors.trim}
            />
          </TouchableOpacity>
          <TouchableOpacity
            onPress={() =>
              this.setState({
                showSnoozed: showSnoozed >= 2 ? 0 : showSnoozed + 1,
              })
            }
            style={{ marginLeft: sizes.base }}
          >
            <FontAwesome
              name="moon-o"
              size={sizes.itemHeight}
              color={buttonColorOptions[showSnoozed]}
            />
          </TouchableOpacity>
          <TouchableOpacity
            onPress={() => this.setState({ redrawKey: redrawKey + 1 })}
            style={styles.icon}
          >
            {/*<MaterialCommunityIcons name="draw" size={sizes.itemHeight} color={colors.trim} />*/}
            <Text style={{ color: colors.trim }}>RE</Text>
          </TouchableOpacity>
          <TouchableOpacity
            onPress={() =>
              this.setState({
                showDoneToday: showDoneToday >= 2 ? 0 : showDoneToday + 1,
              })
            }
            style={styles.icon}
          >
            <FontAwesome
              name={"calendar-check-o"}
              size={sizes.itemHeight - 4}
              color={buttonColorOptions[showDoneToday]}
            />
          </TouchableOpacity>
          <TouchableOpacity
            onPress={() =>
              this.setState({
                showHidden: showHidden >= 2 ? 0 : showHidden + 1,
              })
            }
            style={styles.icon}
          >
            <Ionicons
              name="md-eye-off"
              size={sizes.itemHeight - 4}
              color={buttonColorOptions[showHidden]}
            />
          </TouchableOpacity>
          <TouchableOpacity
            onPress={() => navigation.navigate("Create")}
            style={styles.icon}
          >
            <Ionicons
              name="ios-add-circle-outline"
              size={sizes.itemHeight}
              color={colors.foreground}
            />
          </TouchableOpacity>
        </View>

        {this.renderVisNetwork()}

        <View />
      </View>
    );
  }

  generateNode = (value) => {
    let icon = value.icon || value.rootIcon || "";
    // let color = (value.color || value.inheritedColor)

    let color = valueHelpers.getColor(value);
    let familyColor = valueHelpers.getColor(value, "familyColors") || color;

    let background = colorHelpers.modifyHex(color, 0.6);
    let border = familyColor;

    let x,
      y,
      fixed = undefined;

    return {
      mass: 0.001,
      id: value.id,
      title: valueHelpers.filterRichText(value.titl || value.text),
      label: iconHelpers.unicode(icon),
      font: {
        color,
        face: iconHelpers.fontFamily(icon),
      },
      color: {
        background,
        border,
        hover: {
          background,
          border,
        },
        highlight: {
          border: colors.foreground,
          background: colors.foreground,
        },
      },
      // valueColor: color,
      value: value.level + 1,
      x,
      y,
      fixed,
    };
  };

  renderVisNetwork = () => {
    let {
      values,
      topLevel,
      mapView,
      hierarchical,
      stabalize,
      familyIds,
      network,
    } = this.state;
    values = this.applyFilters(values);

    let rootNode = {
      id: "root",
      label: " ",
      value: topLevel + 2,
      x: 0,
      y: 0,
      fixed: { x: true, y: true },
      valueColor: colors.trim,
      // mass: 3,
      color: {
        background: colors.empty,
        border: colors.trim,
        hover: {
          background: colors.empty,
          border: colors.trim,
        },
        highlight: {
          background: colors.empty,
          border: colors.trim,
        },
      },
    };
    let nodes = [rootNode];
    // nodes = []
    let edges = [];

    let startingLevel = values.filter((v) => !v.parent_ids.length);
    startingLevel.map((v, i) => {
      // if(!familyIds?.length || familyIds.includes(v.id)){
      nodes.push(this.generateNode(v));
      edges.push({ from: "root", to: v.id, color: colors.trim });
      v.child_ids.map((cid) => {
        edges.push({ from: v.id, to: cid, color: v.color });
      });
      // }
    });

    let familyValues = values.filter((v) => familyIds.includes(v.id));
    familyValues.map((v) => {
      if (!nodes.find((n) => n.id == v.id)) {
        let color = valueHelpers.getColor(v);
        nodes.push(this.generateNode(v));
        v.child_ids.map((cid) => {
          edges.push({ from: v.id, to: cid, color: color });
        });
      }
      // else console.log('skipping bc already rendered from top level', v.text)
    });

    // nodes = [{id: 0}] // fix cache

    const graph = { nodes, edges };

    const options = {
      layout: {
        hierarchical: {
          enabled: hierarchical,
          levelSeparation: 150, // default 150
          nodeSpacing: 100, //  Number  100 Minimum distance between nodes on the free axis. This is only for the initial layout. If you enable physics, the node distance there will be the effective node distance.
          treeSpacing: 300, //  Number  200 Distance between different trees (independent networks). This is only for the initial layout. If you enable physics, the repulsion model will denote the distance between the trees.
          // hierarchical.blockShifting  Boolean true  Method for reducing whitespace. Can be used alone or together with edge minimization. Each node will check for whitespace and will shift it's branch along with it for as far as it can, respecting the nodeSpacing on any level. This is mainly for the initial layout. If you enable physics, the layout will be determined by the physics. This will greatly speed up the stabilization time though!
          // hierarchical.edgeMinimization Boolean true  Method for reducing whitespace. Can be used alone or together with block shifting. Enabling block shifting will usually speed up the layout process. Each node will try to move along its free axis to reduce the total length of it's edges. This is mainly for the initial layout. If you enable physics, the layout will be determined by the physics. This will greatly speed up the stabilization time though!
          parentCentralization: false, //  When true, the parents nodes will be centered again after the layout algorithm has been finished.
          // direction: 'DU', //  String  'UD'  The direction of the hierarchical layout. The available options are: UD, DU, LR, RL. To simplify: up-down, down-up, left-right, right-left.
          // sortMethod: 'directed', // String  'hubsize' The algorithm used to ascertain the levels of the nodes based on the data. The possible options are: hubsize, directed.
          sortMethod: "directed", // String  'hubsize' The algorithm used to ascertain the levels of the nodes based on the data. The possible options are: hubsize, directed.
          // Hubsize takes the nodes with the most edges and puts them at the top. From that the rest of the hierarchy is evaluated.
          // Directed adheres to the to and from data of the edges. A --> B so B is a level lower than A.
          // shakeTowards: 'roots', // String  'roots' Controls whether in directed layout should all the roots be lined up at the top and their child nodes as close to their roots as possible (roots) or all the leaves lined up at the bottom and their parents as close to their children as possible (leaves, default).
        },
      },
      physics: {
        enabled: true,
        minVelocity: stabalize ? 2 : 0,
        stabilization: {
          enabled: true,
          iterations: 300,
          fit: true,
        },
        // barnesHut: {
        //   // gravitationalConstant: -70000, // -2000 - lower == greater repulsion
        //   gravitationalConstant: 0, // -2000 - lower == greater repulsion
        //   // centralGravity: 0.2, // 0.3 central pull
        //   // springLength: 100, // 95 - length
        //   springConstant: 0.1, // 0.04 - sturdiness
        //   damping: stabalize ? 2 : 0.6, // 0.09 (0-1) - smoothing
        //   avoidOverlap: 1, // (0-1)
        //   avoidOverlap: 0, // (0-1)
        // },
        hierarchicalRepulsion: {
          // nodeDistance: 50,  //Number  120 This is the range of influence for the repulsion.
          // centralGravity  Number  0.0'  There is a central gravity attractor to pull the entire network back to the center.
          springLength: 100, //  Number  100 The edges are modelled as springs. This springLength here is the rest length of the spring.
          springConstant: 0, //  Number  0.01  This is how 'sturdy' the springs are. Higher values mean stronger springs.
          // damping Number  0.09  Accepted range: [0 .. 1]. The damping factor is how much of the velocity from the previous physics simulation iteration carries over to the next iteration.
        },
      },
      edges: {
        color: "#000000",
        width: 2,
        hoverWidth: 3,
        dashes: true,
        smooth: {
          enabled: false,
          type: "continuous",
        },
        arrows: {
          to: {
            enabled: false,
          },
          //   middle: {
          //     enabled: true,
          //     // imageHeight: 32,
          //     // imageWidth: 32,
          //     scaleFactor: 1,
          //     // src: "https://visjs.org/images/visjs_logo.png",
          //     // type: "image"
          //     type: 'arrow',
          //   },
          //   from: {
          //     enabled: false,
          //   },
        },
      },
      nodes: {
        shape: "circle",
        value: 1,
        scaling: {
          min: 10,
          max: 20,
          label: {
            enabled: true,
            min: 5,
            max: 10,
            maxVisible: 20,
            drawThreshold: 5,
          },
          // customScalingFunction: function (min,max,total,value) {
          //   return value
          // },
          customScalingFunction: function (min, max, total, value) {
            return value * 5;
          },
        },
        borderWidth: 4,
        // borderWidthSelected: 10,
      },
      interaction: {
        hover: true,
        keyboard: {
          enabled: true,
        },
      },
      height: "1100px",
    };

    const events = {
      select: (event) => {
        console.log(event);
        let { nodes, edges } = event;
        if (!!nodes[0] && nodes[0] != "root") {
          network.focus(nodes[0], {
            scale: 1.5,
            // offset: {x:Number, y:Number}
            // locked: boolean
            // animation: { // -------------------> can be a boolean too!
            // duration: Number
            // easingFunction: String
            // }
          });
          let id = nodes[0];
          this.selectById(id);
        } else {
          this.setState({ selectedValueId: null, familyIds: [] });
        }
      },
    };
    return (
      <Graph
        graph={graph}
        options={options}
        events={events}
        ref={(ref) => {
          this[`visRef`] = ref;
        }}
        vis={(vis) => {
          console.log(vis);
          return (this.vis = vis);
        }}
        getNetwork={(network) => {
          //  if you want access to vis.js network api you can set the state in a parent component using this property
          this.setState({ network });
        }}
      />
    );
  };

  selectById = (id) => {
    let { values, selectedValueId } = this.state;
    let value = values.find((v) => v.id == id);
    let familyIds = textHelpers.getFamilyIds(value, values);
    console.log(value);
    console.log(
      familyIds,
      values.filter((v) => familyIds.includes(v.id)).map((v) => v.text),
    );
    if (id == selectedValueId) {
      if (!!value) {
        RootNavigation.navigate("Value", { value, id: value.id });
      }
    } else {
      this.setState({ selectedValueId: id, familyIds });
    }
  };

  applyFilters = (values, affectLeveling = true) => {
    let {
      hideComplete,
      showOnlyStarred,
      showNotes,
      showDoneToday,
      showHidden,
      showSnoozed,
      query,
      hiddenIds,
      showDuplicates,
    } = this.state;
    if (hideComplete) {
      // values = values.filter(v => textHelpers.doneSinceMilestone(v).length < 7 && !v.completed_at)
      values = values.filter((v) => !!!v.completed_at);
    }

    if (showSnoozed == 0)
      // none
      values = values.filter((v) => !valueHelpers.isSnoozed(v));
    else if (showSnoozed == 1)
      // either
      values = values;
    else if (showSnoozed == 2)
      // only
      values = values.filter((v) => valueHelpers.isSnoozed(v));

    if (showOnlyStarred) {
      // values = values.filter(v => v.starred)
    }
    if (!showNotes) {
      values = values.filter((v) => {
        return !v.is_note;
        if (v.child_ids.length == 0) {
          // notes cannot have children
          if (
            v.timeline.length == 2 &&
            v.milestones[0].indexOf("note from") == 0
          ) {
            // only entry is created as a note from parent value
            return false;
          } else if (
            v.timeline.length == 1 &&
            !timeHelpers.wasToday(v.timeline[0].timestamp)
          ) {
            // only entry is created at, and it wasn't today
            return false;
          }
        }
        return true;
      });
    }
    if (showDoneToday == 0 && !affectLeveling) {
      values = values.filter((v) => !textHelpers.wasDoneToday(v, true));
    }
    if (showDoneToday == 2) {
      let doneToday = values.filter((v) => textHelpers.wasDoneToday(v, true));
      let parentIds = doneToday.reduce(
        (ids, val) => [...ids, ...val.parent_ids],
        [],
      );
      while (parentIds.length) {
        let newDoneToday = values.filter(
          (v) => parentIds.indexOf(v.id) >= 0 && doneToday.indexOf(v) < 0,
        );
        parentIds = newDoneToday.reduce(
          (ids, val) => [...ids, ...val.parent_ids],
          [],
        );
        doneToday = [...doneToday, ...newDoneToday];
      }
      values = doneToday;
    }

    hiddenIds = hiddenIds || [];

    if (showHidden == 0 || showHidden == 2) {
      let shouldRemove = showHidden == 2;
      values = values.filter((v) => {
        if (hiddenIds.includes(v.id)) {
          return shouldRemove;
        } else if (v.parent_ids.length == 1) {
          if (hiddenIds.includes(v.parent_ids[0])) {
            // console.log(`hiding ${v.text} bc only parent is hidden: ${v.parent_ids[0]}`)
            hiddenIds.push(v.id);
            return shouldRemove;
          } else {
            return !shouldRemove;
          }
        }
        return !shouldRemove;
      });
    }
    // console.log('hiddenIds', hiddenIds)

    if (!affectLeveling) {
      // hide if level > 0 and no visible children
      // values = values.filter(v => !(v.level > 0 && !values.find(f => v.child_ids.includes(f.id) )))
    }

    values =
      !!query && query.length > 0
        ? values.filter((v) => {
            return (
              v.text.indexOf(query) >= 0 ||
              (!!v.revisions &&
                v.revisions.find((r) => r.text.indexOf(query) >= 0))
            );
          })
        : values;

    return values;
  };

  handleKeyPress = (event) => {
    // console.log('keypress:', event.keyCode, event.keyValue)
    let triggerKey = false;
    // 13 == enter
    // 9 == tab
    if (event.keyCode == 9) {
      return;
      event.preventDefault();
      console.log("tab");
      if (this.state.shiftIsDown) {
        console.log("unindent!");
        // this.handleUnindentItem(item)
      } else {
        // this.handleIndentItem(item)
      }
    } else if (event.keyCode == 13) {
      event.preventDefault();
      console.log("enter");
      // this.handleAppendItem(item)
    } else if (event.keyCode == 8) {
      console.log("backspace");
      // if(item.text == ''){
      // this.handleDeleteItem(item)
      // }
    } else if (event.keyCode == 16) {
      console.log("shift down");
      this.setState({ shiftIsDown: true });
      triggerKey = true;
    } else if (event.keyCode == 27) {
      console.log("escape");
      this.setState({ query: "" });
    }
    // 38 // up
    // 39 // right
    // 40 // down
    // 37 // left
    if (!triggerKey) {
      this.setState({ shiftIsDown: false });
    }
  };
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    flexDirection: "column",
    justifyContent: "space-around",
    backgroundColor: DARK ? undefined : colors.foreground,
  },
  row: {
    flexGrow: 1,
    borderColor: colors.trim,
    // borderBottomWidth: 1,
    alignSelf: "stretch",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    padding: sizes.large,
  },
  queryRow: {
    flexGrow: 0,
    height: 50,
    padding: sizes.base,
    justifyContent: "flex-start",
  },
  input: {
    ...styleSheet.input,
    alignSelf: "stretch",
    flex: 1,
  },
  icon: {
    marginLeft: sizes.base,
    minWidth: sizes.base,
    minHeight: sizes.base,
    // borderWidth: 1, borderColor: 'white',
  },
});
